import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { getVesselMasterList } from "../../redux/actions/mastersAction";
import SuperintendentMasterContent from "../../components/Masters/SuperintendentMaster/SuperintendentMasterContent";

const SuperintendentMaster = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getVesselMasterList({
        active: "",
        searchByFirstName: "",
        limit: "",
        offset: "",
      })
    );
  }, []);

  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <SuperintendentMasterContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default SuperintendentMaster;
